import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Route, Switch } from "react-router-dom";
import Helmet from "react-helmet-async";
import shortid from "shortid";
import selectn from "selectn";

import Navigation from "../Library/Navigation";
import NotFound from "../../dashboard/components/NotFound";
import ScrollToTop from "../Library/ScrollToTop";
import CookieWarning from "components/Library/CookieWarning";
import UniversalRouter from "../../utils/UniversalRouter";

import { routes } from "routes";
import { checkAuthStatus } from "../../utils/auth";
import analytics from "../../utils/analytics";
import { getLocalItem, setLocalItem } from "../../utils/localdb";
import asyncComponent from "utils/asyncComponent";

import styles from "./App.css";
import ogImg from "assets/img/social-default.png";

const AsyncAuthDrawer = asyncComponent(() => import("../Library/AuthDrawer/AuthDrawer"));

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isError: false,
    };
  }

  componentDidMount() {
    this.props.checkAuthStatus();
    analytics.initialize();
  }

  componentWillReceiveProps(nextProps) {
    // If we are trying to log in but didn't succeed or if user logs out, create anon user ga token
    if ((this.props.loggedIn === undefined || this.props.loggedIn) && nextProps.loggedIn === false) {
      this.setAnonymousUser();
    }

    if (!this.props.user && nextProps.user) {
      analytics.setUser(nextProps.user.id);
    }

    if (!this.props.storiesStream.isError && nextProps.storiesStream.isError) {
      const payload = nextProps.storiesStream.error;
      if (payload && payload.handleError && selectn("error.response.status", payload) === 404 &&
        !(nextProps.storiesStream.results.length)) {
        this.setState({ isError: true });
      }
    } else if (this.state.isError && this.props.storiesStream.isError && !nextProps.storiesStream.isError) {
      this.setState({ isError: false });
    }
  }

  setAnonymousUser = () => {
    let anonUser = getLocalItem("anonUser");
    if (!anonUser) {
      anonUser = shortid.generate();
      setLocalItem("anonUser", anonUser);
    }
    analytics.setUser(anonUser);
  };

  render() {
    return (
      <div>
        <Helmet>
          { /* Default meta tags. These get overwritten by other <Helmet> blocks in e.g. articles, etc. */}
          <title>Axios</title>
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://www.axios.com/" />
          <meta property="og:site_name" content="Axios" />
          <meta property="og:image" content={ogImg} />
          <meta name="description" content="Smart, efficient news worthy of your time, attention, and trust" />
          <meta property="og:description" content="Smart, efficient news worthy of your time, attention, and trust" />
          <meta property="fb:app_id" content="650172611997232" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@axios" />
        </Helmet>
        <UniversalRouter context={this.props.context} path={this.props.path}>
          <ScrollToTop>
            <div>
              <CookieWarning />
              <Navigation />
              <AsyncAuthDrawer />
              <div className={styles.root}>
                <Switch>
                  {this.state.isError && (<Route render={({ staticContext }) => {
                    if (staticContext) staticContext.status = 404;
                    return <NotFound />;
                  }} />)}
                  {routes.map((route) => (<Route {...route} key={route.path} />))}
                </Switch>
              </div>
            </div>
          </ScrollToTop>
        </UniversalRouter>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.data,
    loggedIn: state.authDrawer.loggedIn,
    storiesStream: state.storiesStream,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    checkAuthStatus: bindActionCreators(checkAuthStatus, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
